<template>
  <section id="about" class="about container">
    <div class="row">
      <div class="image-box col-4">
        <div class="img-box">
          <img src="img/profile.jpg" alt="" />
        </div>
      </div>
      <div class="text col-8">
        <div class="box">
          <h1>A propos de moi</h1>
          <p>
            Situés à Soumagne depuis plus de 20 ans, nous vous accompagnerons tout au long de votre projet, qu’il
            s’agisse de construction ou de rénovation et cela dans beaucoup de domaines (habitations, immeubles à
            appartements, écoles, maisons de repos, commerces,…)
          </p>
          <p>
            Nous allions technique et créativité tout en étant à l’écoute de vos envies, vos besoins et vos contraintes
            pour réaliser des projets qui vous correspondent. Nous vous proposons des images en 3D qui vous permettront
            de visualiser votre projet. L’impact énergétique occupe une place importante dans nos réalisations.
          </p>
          <p>
            Composé essentiellement d’architectes, le bureau collabore avec des ingénieurs, des géomètres, des
            responsables PEB et des coordinateurs sécurité afin de vous assister durant toutes les étapes de votre
            projet.
          </p>
          <a class="special-cta" href="#contact">Discutons de votre projet</a>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "About",
  data: function() {
    return {
      currentIndex: 0,
    };
  },
};
</script>
